import React from 'react'

import { useTranslation } from 'react-i18next'

function getErrorMessage(errorMessage) {
  const defaultMessage = {
    title: 'reservationNotFoundTitle',
    message: 'mobileReservationNotFoundMessage',
  }
  if (!errorMessage) return defaultMessage

  if (errorMessage.includes('Invalid reservation status')) {
    return { title: 'mobileInvalidReservationStatusTitle' }
  }
  if (errorMessage.includes(`THE PICKUP DATE CAN'T BE PREVIOUS THAN CURRENT DATE!`)) {
    return { title: 'mobilePickupHasPassedTitle' }
  }

  return defaultMessage
}

function InputReservationReferenceErrorPage(props) {
  const { t } = useTranslation()

  const resReference = props.location.search.replace('?resReference=', '') || ""

  const errorWithMessage = getErrorMessage(props.location?.state?.errorMessage)
  return (
    <div className="container">
      <div>
        <div className="home-top text-center pt-4">
          <div className="container">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" />
            </div>
          </div>
        </div>
        <div className="main-inicial">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 pr-5 pl-5 text-center">
                <h2 className="text-uppercase color-grey"><b>{t(errorWithMessage.title)}</b></h2>
              </div>
              <div className="col-12 pb-5 pl-4 pr-4 pt-3 text-center">
                {errorWithMessage.message ? <h2 className="color-green">{t(errorWithMessage.message, { resReference })}</h2> : null}
              </div>
              <div className="col-6">
                <a href="tel:210100200" className="btn btn-green w-100 phone upper">
                  {t('phone')}
                </a>
              </div>
              <div className="col-6">
                <a href="mailto:centralreservas@guerin.com.pt" className="btn btn-green w-100 mail upper">
                  {t('email')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default InputReservationReferenceErrorPage